import jwtDecode from "jwt-decode";

class Auth {
  constructor() {
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.checkSession = this.checkSession.bind(this);
  }

  getCompanyId = () => {
    return localStorage.getItem("company_id");
  };

  getCompanyName = () => {
    return localStorage.getItem("company_name");
  };

  getAccessToken = () => {
    return localStorage.getItem("access_token");
  };

  getEmployeeId() {
    const token = this.getAccessToken();
    const payload = jwtDecode(token);
    return payload.sub;
  }

  getEmployeeName() {
    const token = this.getAccessToken();
    const payload = jwtDecode(token);
    return payload["https://www.cobee.io/name"];
  }

  getCorporationId() {
    const token = this.getAccessToken();
    const payload = jwtDecode(token);
    return payload["https://www.cobee.io/corporationId"];
  }

  checkSession = () => {
    window.location.replace("/");
  };

  isAuthenticated = () => {
    const expiresAtStr = localStorage.getItem("expires_at");
    if (!expiresAtStr) {
      return false;
    }
    const expiresAt = new Date(expiresAtStr);
    return new Date().getTime() < expiresAt.getTime();
  };

  clearStorage = () => {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("expires_in_millis");
    localStorage.removeItem("expires_at");
    // remove data about company
    localStorage.removeItem("company_name");
    localStorage.removeItem("company_id");
    localStorage.removeItem("is_super_admin");
    localStorage.removeItem("corporation_id");
  };
}

const auth0Client = new Auth();

export default auth0Client;
